export const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Image load failed'));

    img.src = src;
  });

export const checkImageDataToRotate = async (imageData) => {
  const image = await loadImage(imageData);

  if (image.naturalWidth > image.naturalHeight) {
    return imageData;
  }

  const canvas = document.createElement('canvas');
  const context = canvas?.getContext('2d');
  canvas.width = image.height;
  canvas.height = image.width;
  context.translate(canvas.width / 2, canvas.height / 2);
  context.rotate((-90 * Math.PI) / 180);
  context.drawImage(image, -image.width / 2, -image.height / 2);
  return canvas.toDataURL('image/jpeg');
};
